import React, { useRef, useMemo } from 'react';
import { Line } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);

const ChartSalada = ({ data, chartId }) => {
    const chartRef = useRef(null);

    const chartData = useMemo(() => {
        const temperatura = data.map(item => item.temperatura ?? null);
        const turbidez = data.map(item => item.turbidez ?? null);
        const conductividad = data.map(item => item.conductividad ?? null);
        const intensidad = data.map(item => item.intensidad ?? null);
        const pH = data.map(item => item.pH ?? null);
        const salinidad = data.map(item => item.salinidad ?? null);
        const oleaje = data.map(item => item.oleaje ?? null);
        const hora = data.map(item => item.fecha ?? '');


        return {
            labels: hora,
            datasets: [
                {
                    label: 'Temperature',
                    data: temperatura,
                    borderColor: 'rgb(220, 20, 60)',
                    backgroundColor: 'rgba(220, 20, 60, 0.5)',
                },
                {
                    label: 'Turbidity',
                    data: turbidez,
                    borderColor: 'rgb(65, 105, 225)',
                    backgroundColor: 'rgba(65, 105, 225, 0.5)',
                },
                {
                    label: 'Conductivity',
                    data: conductividad,
                    borderColor: 'rgb(255, 255, 0)',
                    backgroundColor: 'rgba(255, 255, 0, 0.5)',
                },
                {
                    label: 'Light intensity',
                    data: intensidad,
                    borderColor: 'rgb(255, 125, 125)',
                    backgroundColor: 'rgba(255, 125, 125, 0.5)',
                },
                {
                    label: 'pH',
                    data: pH,
                    borderColor: 'rgb(0, 255, 0)',
                    backgroundColor: 'rgba(0, 255, 0, 0.5)',
                },
                {
                    label: 'Surf',
                    data: oleaje,
                    borderColor: 'rgb(0, 255, 255)',
                    backgroundColor: 'rgba(0, 255, 255, 0.5)',
                },
                {
                    label: 'Salinity',
                    data: salinidad,
                    borderColor: 'rgb(60, 125, 100)',
                    backgroundColor: 'rgba(60, 125, 100, 0.5)',
                }
            ],
        };
    }, [data]);

    const chartOptions = useMemo(() => ({
        responsive: true,
        interaction: {
            mode: 'index',
            intersect: false,
        },
        plugins: {
            legend: {
                display: true,
                position: 'top',
            },
            title: {
                display: true,
                text: 'Relation saltwater node',
            },
        },
    }), []);

    return (
        <Line
            id={`chart-${chartId}`}
            key={chartId}
            ref={chartRef}
            data={chartData}
            options={chartOptions}
        />
    );
};

export default ChartSalada;
